import React from 'react';
const items = [{
  emoji: '📖',
  pages: '350+ pages',
  title: 'Système Functional Complet',
  desc: 'Workouts, planning, progressions, mobility et classes premium.'
}, {
  emoji: '🧠',
  pages: '80+ pages',
  title: 'Coaching & Professional System',
  desc: 'Leadership, expérience, gestion des classes et atmosphère premium.'
}, {
  emoji: '📋',
  pages: '50+ pages',
  title: 'Client Tracking & Coaching Dashboard',
  desc: 'Gestion professionnelle de vos clients.'
}, {
  emoji: '🎨',
  pages: '40+ pages',
  title: 'Templates Social & Branding',
  desc: 'Pour paraître un coach premium aussi en ligne.'
}];
const previews = [{
  icon: '🏋️',
  label: 'Workouts dashboards professionnels'
}, {
  icon: '📅',
  label: 'Planning hebdomadaires premium'
}, {
  icon: '🧘',
  label: 'Mobility flow déjà prêts'
}, {
  icon: '👩',
  label: 'Women functional templates'
}, {
  icon: '📋',
  label: 'Coaching sheets modernes'
}, {
  icon: '📊',
  label: 'Class planners visuels'
}, {
  icon: '🔄',
  label: 'Recovery system'
}, {
  icon: '📱',
  label: 'Templates social media'
}];
export function ContentPreview() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-y border-border-light" data-id="element-35">
      <div className="max-w-5xl mx-auto" data-id="element-36">
        <div className="text-center mb-14" data-id="element-37">
          <h2 className="font-display text-3xl sm:text-5xl font-bold text-white mb-4 tracking-tight uppercase" data-id="element-38">
            📦 Ce que vous recevez immédiatement
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-39">
            <span className="text-primary font-bold" data-id="element-40">
              Plus de 500+ pages de matériel premium prêt à l'emploi.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 sm:gap-6 mb-20" data-id="element-41">
          {items.map((item, i) => <div key={i} className="bg-bg-alt rounded-sm border border-border-light overflow-hidden flex flex-col relative group hover:-translate-y-1 hover:border-primary/40 transition-all duration-300" data-id="element-42">
              <div className="bg-primary h-1 w-full" data-id="element-43" />
              <div className="flex-1 flex flex-col p-7 relative" data-id="element-44">
                <span className="text-4xl mb-3 block relative z-10" data-id="element-45">
                  {item.emoji}
                </span>
                <span className="inline-block self-start font-display text-primary font-bold text-xs uppercase tracking-wider bg-primary/10 px-3 py-1 rounded-sm border border-primary/30 mb-3" data-id="element-46">
                  {item.pages}
                </span>
                <h3 className="font-display text-lg sm:text-xl font-bold text-white uppercase tracking-wide leading-snug mb-3" data-id="element-47">
                  {item.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-48">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Inside material preview */}
        <div className="relative" data-id="element-49">
          <div className="text-center mb-10" data-id="element-50">
            <h3 className="font-display text-2xl sm:text-4xl font-bold text-white inline-flex items-center gap-3 uppercase tracking-tight" data-id="element-51">
              <span data-id="element-52">📸</span> Découvrez le matériel de l'intérieur
            </h3>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-10" data-id="element-53">
            {previews.map((p, i) => <div key={i} className="bg-bg-alt border border-border-light rounded-sm p-5 text-center hover:border-primary/40 hover:-translate-y-1 transition-all group" data-id="element-54">
                <div className="text-3xl sm:text-4xl mb-3 group-hover:scale-110 transition-transform" data-id="element-55">
                  {p.icon}
                </div>
                <p className="text-white text-xs sm:text-sm font-bold uppercase tracking-wide leading-snug" data-id="element-56">
                  {p.label}
                </p>
              </div>)}
          </div>

          <div className="bg-primary/10 border border-primary/40 rounded-sm p-6 text-center" data-id="element-57">
            <p className="text-white font-medium text-base sm:text-lg leading-relaxed" data-id="element-58">
              🔥 Chaque page a été conçue pour ressembler à un vrai{' '}
              <span className="text-primary font-bold" data-id="element-59">
                système elite de studio functional premium
              </span>
              .
            </p>
          </div>
        </div>
      </div>
    </section>;
}